<template>
    <div class="home">
        <!-- <div class="flybox" @click="experience()">免费<br/>体验</div> -->
       <div class="container">
           <h3>易猎云招聘管理系统</h3>
           <p>专注于RPO领域的数字化招聘管理系统，主要帮助RPO类企业解决批量招聘的效率、管理、渠道以及内部协同等问题</p>
           <div class="banimg">
               <img src="https://img.yilieyun.com/oss/ylyh5officialWebimagese/pic_0s2@2x.png"/>
           </div>
           <!-- <div class="experience" @click="experience">免费体验</div> -->
       </div>
       <div class="banbox">
           <div class="efficiency">
           </div>
           <div class="solve">
               <h3 style="font-size: .14rem;font-weight: 400;">易猎云产品</h3>
               <div class="solve_box">
                  <div class="solve_item" :class="{'solve_item_click':proindex==index}" v-for="(item,index) in solvelist" :key="index" @click="proclick(index)">
                    <img :src="item.icon"/>
                    <h4>{{item.title}}</h4>
                    <span>{{item.text}}</span>
                  </div>
                  
               </div>
           </div>
       </div>
       <div class="new_advantage">
         <h3 style="font-size: .14rem;font-weight: 400;">易猎云产品优势</h3>
            <van-swipe :autoplay="3000" :height="110">
                <van-swipe-item>
                    <div class="adv_container">
                        <div class="adv_left">
                            <img src="https://img.yilieyun.com/oss/ylyh5officialWebimagese/icon_grasp the deepening@2x.png"/>
                        </div>
                        <div class="adv_right">
                            <p class="adv_r_title">领域深耕</p>
                            <p class="adv_r_text">管理团队均出自国内头部人力资源企业，具备10年以上的行业纵深经验，对招聘和外包业务的本质有更深的理解</p>
                        </div>
                    </div>
                </van-swipe-item>
                <van-swipe-item>
                    <div class="adv_container">
                        <div class="adv_left">
                            <img src="https://img.yilieyun.com/oss/ylyh5officialWebimagese/icon_technical advantage@2x.png"/>
                        </div>
                        <div class="adv_right">
                            <p class="adv_r_title">技术优势</p>
                            <p class="adv_r_text">技术人员大部分来自BAT等一线互联网公司及智联招聘、北森等人力资源公司，拥有丰富的大数据、高并发及人力资源系统架构设计经验</p>
                        </div>
                    </div>
                </van-swipe-item>
                <van-swipe-item>
                    <div class="adv_container">
                        <div class="adv_left">
                            <img src="https://img.yilieyun.com/oss/ylyh5officialWebimagese/icon_advantage of service@2x.png"/>
                        </div>
                        <div class="adv_right">
                            <p class="adv_r_title">服务优势</p>
                            <p class="adv_r_text">专属客户成功团队，结合客户业务制定专属培训方案，使用产品的过程中遇到任何问题都能第一时间跟进及解决，保障客户真正的成功</p>
                        </div>
                    </div>
                    
                </van-swipe-item>
        </van-swipe>
       </div>
        <div class="new_media">
            <h2 style="font-size: .14rem;font-weight: 400;">媒体报道</h2>
            <van-swipe :autoplay="3000" :height="200">
                <van-swipe-item>
                    <div class="media_swip">
                        <div class="swip_left">
                            <img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyh5officialWebimagese/v2/pic2_report_02%402x.png"/>
                            <p class="swip_title">RPO数字化趋势下「易猎云」想要为万亿主流市场造一个“工作系统”</p>
                            <p class="swip_text">打通数据平台，支持私域获客，RPO员工效能方可被充分展现。 据国家统计局数据，截止2020年...</p>
                            <div class="swip_bottom">
                                <div class="swop_bom_left">2022-05.18</div>
                                <div class="swop_bom_right" @click="gotomediamessage('2')">详情&nbsp;></div>
                            </div>
                        </div>
                        <div class="swip_left">
                            <img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyh5officialWebimagese/v2/pic_report_02%402x.png"/>
                            <p class="swip_title">易猎云开创RPO数字化3.0时代,小微企业永久免费</p>
                            <p class="swip_text">近年来，中国作为快速发展的新兴人力资源服务市场，市场规模持续快速增长。根据中智咨询...</p>
                            <div class="swip_bottom">
                                <div class="swop_bom_left">2023-05.17</div>
                                <div class="swop_bom_right" @click="gotomediamessage('5')">详情&nbsp;></div>
                            </div>
                        </div>
                    </div>
                </van-swipe-item>
                <van-swipe-item>
                    <div class="media_swip">
                        <div class="swip_left">
                            <img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyh5officialWebimagese/v2/banner3%402x.png"/>
                            <p class="swip_title">易猎云开启RPO3.0时代，人力管理平台是怎样进行数字化转型的？</p>
                            <p class="swip_text">21世纪什么最重要，是人才!2004年，电影《天下无贼》中葛优的一句经典台词，在时隔近20年后的今天...</p>
                            <div class="swip_bottom">
                                <div class="swop_bom_left">2022-05.17</div>
                                <div class="swop_bom_right" @click="gotomediamessage('1')">详情&nbsp;></div>
                            </div>
                        </div>
                        <div class="swip_left">
                            <img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyh5officialWebimagese/v2/banner4%402x.png"/>
                            <p class="swip_title">最有前景的RPO数字化趋势来到了，工作系统是怎么逆袭的？</p>
                            <p class="swip_text">打通数据平台、支持私域获客，RPO员工效能被充分展现，易猎云更像是一个...</p>
                            <div class="swip_bottom">
                                <div class="swop_bom_left">2022-05.19</div>
                                <div class="swop_bom_right" @click="gotomediamessage('3')">详情&nbsp;></div>
                            </div>
                        </div>
                    </div>
                </van-swipe-item>
            </van-swipe>
        </div>
        <div class="security">
            <h2 style="font-size: .14rem;font-weight: 400;">安全保障</h2>
            <van-swipe :autoplay="3000" :height="200">
                <van-swipe-item>
                    <div class="sec_swip">
                        <div class="sec_left" >
                           <img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyh5officialWebimagese/v2/icon_safe01%402x.png"/>
                           <h3>权威认证</h3>
                           <p style="margin-top: .07rem;">ISO9001质量管理体系认证</p>
                           <p>ISO27001信息安全管理体系认证</p>
                        </div>
                        <div class="sec_left">
                            <img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyh5officialWebimagese/v2/icon_safe02%402x.png"/>
                            <h3>隐私保护</h3>
                            <p style="margin-top: .07rem;">未经客户授权，不会将数据用做业务外</p>
                            <p>的任何用途，不会将数据转移给第三方</p>
                        </div>
                    </div>
                </van-swipe-item>
                <van-swipe-item>
                    <div class="sec_swip">
                        <div class="sec_left" >
                           <img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyh5officialWebimagese/v2/icon_safe03%402x.png"/>
                           <h3>安全管控</h3>
                           <p style="margin-top: .07rem;">严格的信息安全管控机制</p>
                           <p>银行级加密通信及阿里云安全支持</p>
                        </div>
                        <div class="sec_left">
                            <img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyh5officialWebimagese/v2/icon_safe04%402x.png"/>
                            <h3>应用安全</h3>
                            <p style="margin-top: .07rem;">应用级安全保障数据权限最小必须</p>
                            <p>简历敏感信息加密存储及导出规范</p>
                        </div>
                    </div>
                </van-swipe-item>
            </van-swipe>
        </div>
       <div class="advantage">
           <div class="adv__enterprise">
               <h3 style="font-weight: 400;">与更多优秀企业共同成长</h3>
               <div class="adv__box">
                   
               </div>
           </div>
          
           <div class="youxiu">
               <h3 style="font-size: .14rem;">合作伙伴</h3>
               <div class="youxiu__box">
                   <div class="youxiu_child1">
                       <img src="https://img.yilieyun.com/oss/ylyh5officialWebimagese/icon_zhilianzhaopin@2x.png"/>
                   </div>
                   <div class="youxiu_child2">
                       <img src="https://img.yilieyun.com/oss/ylyh5officialWebimagese/icon_qianchenwuyou@2x.png"/>
                   </div>
               </div>
               <div class="youxiu__box" style="margin-top: .2rem;">
                   <div class="youxiu_child1">
                       <img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyh5officialWebimagese/v2/logo_boss%402x.png"/>
                   </div>
                   <div class="youxiu_child2">
                       <img src="https://img.yilieyun.com/oss/ylyh5officialWebimagese/icon_58@2x.png"/>
                   </div>
               </div>
           </div>
           <!-- <div class="trial">
            <div class="tr_title">
                <div class="tr_left">
                    <img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyh5officialWebimagese/v2/icon_customer_service%402x.png"/>
                </div>
                <h2>即刻开启数字化招聘人效提升之旅</h2>
            </div>   
          
               <div class="tr_btn" @click="rogoprice">免费体验</div>
           </div> -->
       </div>
    </div>
</template>
<script>
export default {
    name:'home',
    data(){
        return{
            solvelist:[
                {
                    icon:'https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyh5officialWebimagese/v2/icon_01%402x.png',
                    title:'PRO招聘管理系统',
                    text:'专注于提升招聘效率，帮助RPO企业解决批量招聘的效率、管理、渠道及内部协同问题'
                },
                {
                    icon:'https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyh5officialWebimagese/v2/icon_02%402x.png',
                    title:'HR招聘管理系统',
                    text:'服务于中大型企业招聘团队，解决人才库建设、私域流量、内部推荐、帮助提升招聘效率'
                },
                {
                    icon:'https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyh5officialWebimagese/v2/icon_03%402x.png',
                    title:'HRO外包管理系统',
                    text:'服务于人力资源公司外包业务，实现入离职、花名册、电子合同、商社保增员、发薪包税等服务'
                },
                {
                    icon:'https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyh5officialWebimagese/v2/icon_04%402x.png',
                    title:'企微助手',
                    text:'将企微好友与易猎云招聘系统打通，可展示好友简历信息，职位信息，进行面试安排等操作'
                },
                {
                    icon:'https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyh5officialWebimagese/v2/icon_05%402x.png',
                    title:'易分享',
                    text:'通过易分享小程序，可将职位分享至微信端，裂变增加曝光。支持候选人简历投递，搭建私域人才库'
                },
                {
                    icon:'https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyh5officialWebimagese/v2/icon_06%402x.png',
                    title:'易外呼APP',
                    text:'易猎云外呼App，可在易猎云系统中对候选人发起外呼、短信；支持通话录音、通话统计等功能'
                },
            ],
            proindex:-1,
            routeData: {}

        }
    },
    mounted(){
        if (Object.keys(this.$route.query).length) {
            this.routeData = this.$route.query
        }
        const {u=''} = this.routeData;
        if(!u){
            console.log("WWWW");
            zhuge.track("官网加载", {
                渠道: '移动',
                utm类型: "自然流量",
            });
        }else{
             zhuge.track("官网加载", {
                渠道: '移动',
                utm类型: "驱动流量",
            });
        }
    },
    methods:{
        //免费体验
        experience(){
            this.$router.push({path:'/apply',query:this.routeData});
        },
        rogoprice(){
             this.$router.push({path:'/apply',query:this.routeData});
        },
        gotomediamessage(id){
            if(id==0){
                this.$router.push('/kehujigou');
                document.documentElement.scrollTop = 0;
            }
            if(id==1){
                this.$router.push('/yiou');
                document.documentElement.scrollTop = 0;
            }else if(id==2){
                this.$router.push('/ke');
                document.documentElement.scrollTop = 0;
            }else if(id==5){
                this.$router.push('/yilieyun');
                document.documentElement.scrollTop = 0
            }else if(id==3){
                this.$router.push('/jixin');
                document.documentElement.scrollTop = 0
            }else if(id==4){
                this.$router.push('/timedia');
                document.documentElement.scrollTop = 0
            }

        },
        proclick(index){
            this.proindex=index;
        },
    },
    metaInfo: {
      title: '易猎云招聘管理系统-RPO工作平台-小微企业免费人才库系统',
      meta: [
        {
          name: 'keywords',
          content: '易猎云，招聘管理系统，RPO，批量招聘，免费'
        },
        {
          name: 'description',
          content: '易猎云招聘管理系统，RPO公司批量招聘数字化首选的招聘系统'
        }
      ]
  },
}
</script>
<style lang="less" scoped>
.home{
    margin-top: .43rem;
    background-color: #fff;
    .flybox{
        position: fixed;
        right: 0;
        top: .9rem;
        width: .48rem;
        height: .40rem;
        background: #0084FF;
        border-radius: 10px;
        color: #ffffff;
        font-size: .14rem;
        text-align: center;
        padding-top: .1rem;
        padding-bottom: .1rem;
        z-index: 999;
    }
    .container{
        width: 100%;
        height: 3.75rem;
        background: #ffffff;
        padding-top: .25rem;
        h3{
            font-size: .24rem;
            color: #1D2754;
            line-height: .33rem;
            text-align: center;
        }
        p{
            width: 2.79rem;
            height: .56rem;
            font-size: .12rem;
            margin: 0 auto;
            margin-top: .16rem;
            text-align: justify;
            text-indent: 2em;
        }
        .banimg{
            width: 2.35rem;
            height: 1.77rem;
            margin: 0 auto;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .experience{
            width: 1.54rem;
            height: .46rem;
            background: #0084FF;
            border: none;
            border-radius: 7px;
            font-size: .18rem;
            color: #ffffff;
            line-height: .46rem;
            margin-left: 50%;
            transform: translate(-50%);
            text-align: center;
            margin-top: .14rem;
        }
    }
    .banbox{
        width: 100%;
        background: #ffffff;
        margin-bottom: .3rem;
        .efficiency{
            display: flex;
            width: 100%;
            height: .7rem;
            background-image: url('https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyh5officialWebimagese/v2/pic_02%402x.png');
            background-size: 101%;
            background-repeat: no-repeat;
        }
        .solve{
            width: 100%;
            h3{
                font-size: .18rem;
                color: #1D2754;
                text-align: center;
                margin-top: .26rem;
            }
            .solve_box{
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                padding-left: .3rem;
                padding-right: .3rem;
                box-sizing: border-box;
                .solve_item{
                   position: relative;
                   width: 46%;
                   height: 1.84rem;
                   background: linear-gradient( 180deg, #EFF7FF 0%, #FFFFFF 100%);
                   box-shadow: 0px 1px 9px 2px #F4F8FC;
                   border-radius: 4px;
                   margin-top: .2rem;
                   padding-top: .12rem;
                   box-sizing: border-box;
                   img{
                    position: absolute;
                    width: 60px;
                    height: 48px;
                    left: 50%;
                    transform: translateX(-50%);
                   }
                   h4{
                    width: 100%;
                    position: absolute;
                    font-size: .11rem;
                    top: .8rem;
                     text-align: center;
                   }
                   span{
                    position: absolute;
                    display: inline-block;
                    font-size: .09rem;
                    top: 1.03rem;
                    padding-left: .14rem;
                    padding-right: .14rem;
                   }
                }
                .solve_item_click{
                    background: linear-gradient( 180deg, #1C83FF 0%, #0972ED 100%);
                    color: #FFFFFF;
                }
            }
        }
       
    }
    .new_advantage{
        width: 100%;
        height: 1.5rem;
        background-image: url('https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyh5officialWebimagese/v2/bg_blue%402x.png');
        background-size: 100%;
        background-repeat: no-repeat;
        h3{
            text-align: center;
            font-size: .11rem;
            color: #313236;
            line-height: .44rem;
            padding-top: .05rem
        }
        .adv_container{
            display: flex;
            width: 100%;
            height: .68rem;
            padding-left: .66rem;
            padding-right: .66rem;
            padding-top: .01rem;
            box-sizing: border-box;
            .adv_left{
                width: .43rem;
                height: .43rem;
                position: relative;
                img{
                    position: absolute;
                    left: 0px;
                    top: 0px;
                }
            }
            .adv_right{
                flex: 1;
                margin-left: .12rem;
                .adv_r_title{
                    font-size: 12px;
                    color: #1D2754;
                    line-height: .14rem;
                    font-weight: bold;
                }
                .adv_r_text{
                    font-size: .09rem;
                    color: #1D2754;
                    line-height: .16rem;
                    margin-top: .06rem;
                }
            }
        }
    }
    .new_media{
        width: 100%;
        height: 2.18rem;
        background-color: #ffffff;
        h2{
            font-size: .11rem;
            color: #1D2754;
            line-height: .16rem;
            text-align: center;
            margin-top: .22rem;
            margin-bottom: .14rem;
        }
        .media_swip{
            display: flex;
            justify-content: space-between;
            width: 100%;
            height: 1.53rem;
            padding-left: .2rem;
            padding-right: .2rem;
            box-sizing: border-box;
            .swip_left{
                position: relative;
                width: 48%;
                height: 1.53rem;
                box-shadow: 2px 5px 21px 0px #E0E0EE;
               img{
                position: absolute;
                width: 100%;
                height: .75rem;
                left: 0px;
                top: 0px;
                border-top-left-radius: 6px;
                border-top-right-radius: 6px;
                border-bottom-left-radius: 0px;
                border-bottom-right-radius: 0px;
               }
               .swip_title{
                 font-size: .08rem;
                 color: #1D2754;
                 margin-top: .8rem;
                 margin-left: .06rem;
                 margin-right: .06rem;
                 font-weight: bold;
               }
               .swip_text{
                font-size: .06rem;
                color: #7F8590;
                line-height: .1rem;
                margin-left: .06rem;
                margin-right: .06rem;
                margin-top: .06rem;
               }
               .swip_bottom{
                display: flex;
                width: 100%;
                height: .12rem;
                margin-top: .07rem;
                .swop_bom_left{
                    flex: 1;
                    font-size: .06rem;
                    color: #979DA6;
                    line-height: .08rem;
                    margin-left: .06rem;
                }
                .swop_bom_right{
                    flex: 1;
                    color: #215FFF;
                    font-size: .06rem;
                    text-align: right;
                    margin-right: .06rem;
                }
               }
            }
        }
    }
    .security{
        width: 100%;
        height: 2.18rem;
        background-image: url('https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyh5officialWebimagese/v2/bg_01%402x.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        padding-top: .22rem;
        box-sizing: border-box;
        h2{
            font-size: .11rem;
            color: #ffffff;
            line-height: .16rem;
            text-align: center;
        }
        .sec_swip{
            display: flex;
            justify-content: space-between;
            width: 100%;
            height: 1.33rem;
            padding-left: .2rem;
            padding-right: .2rem;
            box-sizing: border-box;
            margin-top: .15rem;
            .sec_left{
                position: relative;
                width: 47%;
                height: 1.33rem;
                border: solid 2px #3F87F0;
                border-radius: .06rem;
                background-color: #052759;
                img{
                    position: absolute;
                    width: .4rem;
                    height: .45rem;
                    left: 50%;
                    transform: translateX(-50%);
                    margin-top: .15rem;
                }
                h3{
                    text-align: center;
                    font-size: .1rem;
                    color: #ffffff;
                    margin-top: .65rem;
                }
                p{
                    font-size: .08rem;
                    color: #ffffff;
                    margin-left: .15rem;
                    line-height: .15rem;
                }
            }
        }


    }
    .advantage{
        width: 100%;
        // height: 7.64rem;
        .adv__enterprise{
            width: 100%;
            height: 2.93rem;
            background-image: url('https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyh5officialWebimagese/v2/wrod%402x.png');
            background-repeat: no-repeat;
            background-size: 100%;
            padding-top: .1rem;
            box-sizing: border-box;
            h3{
                font-size: .14rem;
                color: #ffffff;
                line-height: .44rem;
                text-align: center;
            }
            .adv__box{
                width: 3.14rem;
                height:1.96rem;
                background: #ffffff;
                padding-top: .15rem;
                margin: 0 auto;
                background-image: url('https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyh5officialWebimagese/v2/new_pic_logo%20wall%402x.png');
                background-size: 100%;
                background-repeat: no-repeat;
            }
        }
        .trial{
            width: 100%;
            height: 1.14rem;
            background-image: url('https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyh5officialWebimagese/v2/bg_0133%402x.png');
            background-repeat: no-repeat;
            background-size: 105% 1.57rem;
            background-position: -.1rem;
            padding-top: .15rem;
            box-sizing: border-box;
            .tr_title{
                width: 73%;
                margin: 0 auto;
                display: flex;
                .tr_left{
                    position: relative;
                    width: .45rem;
                    img{
                        position: absolute;
                        margin-top: .02rem;
                    }
                }
                h2{
                    flex: 1;
                    font-size: .14rem;
                    font-weight: 500;
                    color: #FFFFFF;
                    line-height: .43rem;
                    text-align: left;
                    margin-left: .1rem;
                }
            }
          
            .tr_btn{
                width: .81rem;
                height: .29rem;
                border-radius: 3px;
                background: #FFFFFF;
                font-size: .14rem;
                color: #215FFF;
                line-height: .29rem;
                text-align: center;
                margin: 0 auto;
                margin-top: .1rem;
            }
        }
        .youxiu{
            width: 100%;
            height: 1.82rem;
            padding-top: .1rem;
            background: #ffffff;
            h3{
                font-size: .14rem;
                color: #1D2754;
                text-align: center;
                font-weight: 400;
                line-height: .44rem;
            }
            .youxiu__box{
                display: flex;
                width: 65%;
                height: .45rem;
                margin: 0 auto;
                .youxiu_child1{
                    position: relative;
                    flex: 1;
                    border-radius: 2px;
                    border: 1px solid #D9DAE5;
                    img{
                        position: absolute;
                        width: .8rem;
                        height: .18rem;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%,-50%);
                    }
                }
                .youxiu_child2{
                    position: relative;
                    flex: 1;
                    margin-left: .13rem;
                    border-radius: 2px;
                    border: 1px solid #D9DAE5; 
                    img{
                        position: absolute;
                        width: .8rem;
                        height: .28rem;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%,-50%);
                    }
                }

            }
        }
    }
}
</style>
<style>
.van-swipe__indicator {
    background-color: #215FFF !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/home/index.vue